function getUrlQueryParam(param) {
  const url = new URL(window.location.href);
  const value = url.searchParams.get(param);

  return value != null ? value : '';
}

export {
  // eslint-disable-next-line import/prefer-default-export
  getUrlQueryParam,
};
